import { useState, useCallback } from "react"

interface UseCopyToClipboardResult {
    copied: boolean
    copy: (text: string) => Promise<void>
}

export function useCopyToClipboard(): UseCopyToClipboardResult {
    const [copied, setCopied] = useState(false)

    /**
     * on non https environments the navigator is not available,
     * this function provide a fallback for these cases
     */
    const unsecuredCopyToClipboard = (text: string) => {
        const textArea = document.createElement("textarea")
        textArea.value = text
        document.body.appendChild(textArea)
        textArea.select()
        try {
            document.execCommand("copy")
        } catch (err) {
            console.error("Unable to copy to clipboard", err)
        }
        document.body.removeChild(textArea)
    }

    const copy = useCallback(async (text: string) => {
        try {
            if (window.isSecureContext && navigator.clipboard) {
                navigator.clipboard.writeText(text)
            } else {
                unsecuredCopyToClipboard(text)
            }
            setCopied(true)
            setTimeout(() => setCopied(false), 2000)
        } catch (error) {
            console.error("Failed to copy text to clipboard:", error)
        }
    }, [])

    return { copied, copy }
}
